var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_vm.methodType === 'COUNTER' ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Due Running Hours")]), _c('InputCurrency', {
    staticClass: "w-100",
    attrs: {
      "prepend": "",
      "placeholder": "input hours",
      "disabled": "",
      "append": "Hours"
    },
    model: {
      value: _vm.postpone.possible_maintenance_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.postpone, "possible_maintenance_hours", _vm._n($$v));
      },
      expression: "postpone.possible_maintenance_hours"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "text-muted"
  }, [_vm._v("Extra Hours")]), _c('InputCurrency', {
    staticClass: "w-100",
    attrs: {
      "prepend": "",
      "append": "Hours",
      "placeholder": "input hours"
    },
    model: {
      value: _vm.postpone.extra_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.postpone, "extra_hours", _vm._n($$v));
      },
      expression: "postpone.extra_hours"
    }
  })], 1)], 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Due Date",
      "label-for": "due-date"
    }
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "id": "due-date",
      "disabled": "",
      "type": "date"
    },
    model: {
      value: _vm.dueDateLocal,
      callback: function callback($$v) {
        _vm.dueDateLocal = $$v;
      },
      expression: "dueDateLocal"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Postponed Date *",
      "label-for": "postponed-date"
    }
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "id": "postponed-date",
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.postpone.extra_date,
      callback: function callback($$v) {
        _vm.$set(_vm.postpone, "extra_date", $$v);
      },
      expression: "postpone.extra_date"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Postponed Attachment"
    }
  }, [_c('input', {
    ref: "postponeFileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFilesSelected
    }
  }), _c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.openFilePicker
    }
  }, [_c('i', {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Add Attachment ")]), _c('div', {
    staticClass: "mt-2"
  }, [_vm._l(_vm.existingAttachments, function (f, idx) {
    return _c('b-badge', {
      key: "existing-file-".concat(idx),
      staticClass: "mr-2 mb-2 align-middle",
      attrs: {
        "variant": "warning",
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(f.filename || f.name || 'attachment') + " "), _c('b-button', {
      staticClass: "p-0 ml-1",
      attrs: {
        "size": "xs",
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.removeExistingFile(idx);
        }
      }
    }, [_vm._v(" × ")])], 1);
  }), _vm._l(_vm.files, function (f, idx) {
    return _c('b-badge', {
      key: "file-".concat(idx),
      staticClass: "mr-2 mb-2 align-middle",
      attrs: {
        "variant": "warning",
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(f.name) + " "), _c('b-button', {
      staticClass: "p-0 ml-1",
      attrs: {
        "size": "xs",
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFile(idx);
        }
      }
    }, [_vm._v(" × ")])], 1);
  })], 2), _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" File Type: .pdf .xls .xlsx .doc .docx .jpg .jpeg .png | Max File Size: 2 MB ")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Reason Postponed"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "5",
      "placeholder": "Tulis alasan penundaan..."
    },
    model: {
      value: _vm.postpone.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.postpone, "reason", $$v);
      },
      expression: "postpone.reason"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mt-3"
  }, [_c('div'), _c('div', {
    staticClass: "ml-auto d-flex"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.loading
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Submit ")], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }